import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Col, Container, Row } from 'reactstrap';
//Import Icons
import FeatherIcon from 'feather-icons-react';

// Import Images
// Import Images
import client1 from '../../assets/images/client/jabq.jpeg';
// import client2 from '../../assets/images/client/02.jpg';
// import client3 from '../../assets/images/client/03.jpg';
// import client4 from '../../assets/images/client/04.jpg';

const MindPower = () => {
  return (
    <React.Fragment>
      <Container className="mt-100 mt-60">
        <Row className="justify-content-center">
          <Col xs={12}>
            <div className="section-title text-center mb-4 pb-2">
              <h4 className="title mb-4">Nuestro Equipo</h4>
              <p className="text-muted para-desc mx-auto mb-0">
                Empieza a trabajar con{' '}
                <span className="text-primary fw-bold">Watopa</span> para llevar tu negocio al siguiente nivel.
              </p>
            </div>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <div className="col-lg-3 col-md-6 mt-4 pt-2">
            <div className="card team team-primary text-center border-0">
              <div className="position-relative">
                <img
                  src={client1}
                  className="img-fluid avatar avatar-ex-large rounded-circle shadow"
                  alt=""
                />
                <ul className="list-unstyled mb-0 team-icon">
                  <li className="list-inline-item">
                    <Link
                      to="#"
                      className="btn btn-primary btn-pills btn-sm btn-icon"
                    >
                      <i>
                        <FeatherIcon icon="linkedin" className="icons" />
                      </i>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="card-body py-3 px-0 content">
                <h5 className="mb-0">
                  <Link to="#" className="name text-dark">
                    Jhon Barrantes
                  </Link>
                </h5>
                <small className="designation text-muted">CEO & Founder</small>
              </div>
            </div>
          </div>

          <Col lg={3} md={6} className="mt-4 pt-2">
            <div className="card team team-primary text-center border-0">
              <div className="position-relative">
                <img
                  // src={client4}
                  className="img-fluid avatar avatar-ex-large rounded-circle shadow"
                  alt=""
                />
                <ul className="list-unstyled mb-0 team-icon">
                   <li className="list-inline-item">
                    <Link
                      to="#"
                      className="btn btn-primary btn-pills btn-sm btn-icon"
                    >
                      <i>
                        <FeatherIcon icon="linkedin" className="icons" />
                      </i>
                    </Link>
                  </li>{' '}
                </ul>
              </div>
              <div className="card-body py-3 px-0 content">
                <h5 className="mb-0">
                  <Link to="#" className="name text-dark">
                    Antonio Díaz
                  </Link>
                </h5>
                <small className="designation text-muted">Co Founder</small>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};
export default MindPower;
